import React from "react";

import { clsx } from "clsx";

import {
  BannerCarousel,
  Banner as BannerSwiper,
  CarouselSection,
} from "@bared/ui";
import { withBanner, type BannerOutputProps } from "./withBanner";

import { Link } from "~/components/Link";
import { AnalyticsCreativeSlot } from "~/components/AnalyticsCreativeSlot";

const Overlay = (props: any) => (
  <div
    {...props}
    className={clsx(props.className, "absolute z-10 h-full w-full")}
    style={
      props.rgb
        ? {
            backgroundColor: `rgba(${props.rgb.r},${props.rgb.g},${props.rgb.b},${props.rgb.a})`,
          }
        : {}
    }
  />
);

const Banner = ({
  bannerContent,
  transparentHeader,
  anchorId,
}: BannerOutputProps) => (
  <>
    {bannerContent && bannerContent?.length > 0 ? (
      <BannerCarousel
        ariaLabel="Banner Swipers"
        data-component-type="section-banner"
        transparentHeader={transparentHeader}
        className={clsx(
          bannerContent.length > 1 && "overflow-hidden pb-mini",
          "hide-scrollbar",
        )}
      >
        {bannerContent.map((banner, index) => {
          const {
            desktopContent,
            desktopContentAlignment,
            desktopImage,
            desktopImageAspectRatio,
            desktopImagelink,
            desktopVideoUrl,
            mobileContent,
            mobileContentAlignment,
            mobileImage,
            mobileImageAspectRatio,
            mobileVideoUrl,
            textColor,
            maxContentWidth,
            cta,
            overlayBackgroundColour,
          } = banner;

          const inner = (
            <BannerSwiper
              desktopContent={desktopContent}
              desktopContentAlignment={desktopContentAlignment}
              desktopImage={desktopImage}
              desktopImageAspectRatio={desktopImageAspectRatio}
              desktopImagelink={desktopImagelink}
              desktopVideoUrl={desktopVideoUrl}
              mobileContent={mobileContent}
              mobileContentAlignment={mobileContentAlignment}
              mobileImage={mobileImage}
              mobileImageAspectRatio={mobileImageAspectRatio}
              mobileVideoUrl={mobileVideoUrl}
              textColor={textColor}
              maxContentWidth={maxContentWidth}
              cta={cta}
            >
              <Overlay
                rgb={overlayBackgroundColour?.rgb}
                className="top-zero"
              />
            </BannerSwiper>
          );

          return (
            <CarouselSection index={index} key={`banner-swiper-${index}`}>
              <AnalyticsCreativeSlot
                name={`${anchorId ?? "Banner"} - Section ${index + 1}`}
              >
                {desktopImagelink?.url ? (
                  <div
                    className="relative w-full cursor-pointer"
                    onClick={() =>
                      desktopImagelink.url &&
                      (window.location.href = desktopImagelink.url)
                    }
                    onKeyDown={(e) => {
                      if (
                        (e.key === "Enter" || e.key === " ") &&
                        desktopImagelink.url
                      ) {
                        window.location.href = desktopImagelink.url;
                      }
                    }}
                    tabIndex={-1}
                    role="button"
                    aria-label="Banner link"
                  >
                    {inner}
                  </div>
                ) : (
                  inner
                )}
              </AnalyticsCreativeSlot>
            </CarouselSection>
          );
        })}
      </BannerCarousel>
    ) : null}
  </>
);

export default withBanner(Banner);
